import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { useContent } from '../content/ContentContext';
import { Reveal, Kicker } from '../components/Reveal';
import { SEO } from '../components/SEO';
import { IMG, Banner } from './Home';

const IMG_DEFAULTS = [IMG.locationNew, IMG.cookingNew, IMG.wine, IMG.mixology, IMG.pianoTerra, IMG.promozione, IMG.catering];
const spans = ['md:col-span-12', 'md:col-span-7', 'md:col-span-5', 'md:col-span-5', 'md:col-span-7', 'md:col-span-7', 'md:col-span-5'];

export default function Servizi() {
  const { t } = useLanguage();
  const { img, ct } = useContent();
  const imgs = IMG_DEFAULTS.map((d, i) => img(`serv-${i}`, d));

  return (
    <div data-testid="servizi-page">
      <SEO title={t.meta.serviziTitle} description={t.meta.serviziDesc} />

      <section className="bg-emerald-deep grain relative pt-40 pb-24 md:pb-32" data-testid="servizi-hero">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <Reveal>
            <Kicker light>{t.servizi.kicker}</Kicker>
            <h1 className="mt-6 font-serif text-4xl sm:text-5xl lg:text-6xl text-ivory tracking-tight max-w-3xl">{t.servizi.title}</h1>
            <p className="mt-6 max-w-2xl text-ivory/70 text-base md:text-lg leading-relaxed">{t.servizi.intro}</p>
          </Reveal>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {t.servizi.items.map((item, i) => (
            <Reveal key={item.title} delay={(i % 2) * 0.1} className={spans[i]}>
              <article
                data-testid={`servizio-card-${i}`}
                className="group h-full bg-white border border-emerald/10 rounded-sm overflow-hidden flex flex-col transition-all duration-500 hover:shadow-[0_12px_50px_rgba(37,79,87,0.14)] hover:-translate-y-1"
              >
                <div className="img-frame">
                  <img src={imgs[i]} alt={item.title} className="w-full aspect-[16/8] object-cover" loading="lazy" />
                </div>
                <div className="p-8 md:p-10 flex flex-col flex-1">
                  <span className="font-serif italic text-terracotta/70 text-2xl">{String(i + 1).padStart(2, '0')}</span>
                  <h2 className="mt-3 font-serif text-3xl text-emerald tracking-tight">{ct(`serv_title_${i}`, item.title)}</h2>
                  <p className="mt-4 text-sm md:text-base text-emerald-ink/60 leading-relaxed flex-1">{ct(`serv_desc_${i}`, item.desc)}</p>
                  <Link
                    to="/contatti"
                    data-testid={`servizio-cta-${i}`}
                    className="mt-8 inline-flex items-center gap-3 text-sm font-medium text-terracotta-dark tracking-wide group/link"
                  >
                    {t.servizi.cardCta}
                    <ArrowRight size={16} className="transition-transform duration-300 group-hover/link:translate-x-1" />
                  </Link>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>

      <Banner title={t.servizi.bannerTitle} text={t.servizi.bannerText} cta={t.servizi.bannerCta} />
    </div>
  );
}
